/* DON'T EDIT THIS FILE: edit original and run build again */ import { Roles } from "../../framework/permission/schema.ts";
import { PermissionCollection } from "../../framework/permission/types.ts";
import {
  canListOnboardingsWithCommonStatuses,
  canListOnboardingsWithInfoRequestStatus,
  canListOnboardingsWithInitialLoadStatus,
  canViewOnboardingsWithCommonStatuses,
  canViewOnboardingsWithInfoRequestStatus,
  canViewOnboardingsWithInitialLoadStatus,
} from "./permissions.ts";

const onboardingsStatusPermissions: PermissionCollection = {
  namespace: "onboarding",
  permissions: [
    {
      name: canListOnboardingsWithCommonStatuses,
      description:
        "Puede listar los Onboardings en estados comunes: todos excepto Carga en proceso o Solicitud de información",
      roles: [
        Roles.sales,
        Roles.salesManager,
        Roles.producer,
        Roles.headOfProducers,
        Roles.admin,
        Roles.tenantAdmin,
        Roles.complianceOfficer,
        Roles.backOffice,
        Roles.trader,
        Roles.auneSupport,
      ],
    },
    {
      name: canViewOnboardingsWithCommonStatuses,
      description:
        "Puede ver los Onboardings en estados comunes: todos excepto Carga en proceso o Solicitud de información",
      roles: [
        Roles.sales,
        Roles.salesManager,
        Roles.producer,
        Roles.headOfProducers,
        Roles.admin,
        Roles.tenantAdmin,
        Roles.complianceOfficer,
        Roles.backOffice,
        Roles.trader,
        Roles.auneSupport,
      ],
    },
    {
      name: canListOnboardingsWithInfoRequestStatus,
      description:
        "Puede listar Onboardings en estado Solicitud de información",
      roles: [
        Roles.sales,
        Roles.salesManager,
        Roles.producer,
        Roles.headOfProducers,
        Roles.admin,
        Roles.tenantAdmin,
        Roles.complianceOfficer,
        Roles.backOffice,
        Roles.trader,
        Roles.auneSupport,
      ],
    },
    {
      name: canViewOnboardingsWithInfoRequestStatus,
      description:
        "Puede ver los Onboardings en estado Solicitud de información",
      roles: [
        Roles.sales,
        Roles.salesManager,
        Roles.producer,
        Roles.headOfProducers,
        Roles.admin,
        Roles.tenantAdmin,
        Roles.complianceOfficer,
        Roles.backOffice,
        Roles.trader,
        Roles.endClientUser,
        Roles.auneSupport,
      ],
    },
    {
      name: canListOnboardingsWithInitialLoadStatus,
      description: "Puede listar Onboardings en estado Carga en Proceso",
      roles: [
        Roles.sales,
        Roles.salesManager,
        Roles.producer,
        Roles.headOfProducers,
        Roles.admin,
        Roles.tenantAdmin,
        Roles.complianceOfficer,
        Roles.backOffice,
        Roles.trader,
        Roles.auneSupport,
      ],
    },
    {
      name: canViewOnboardingsWithInitialLoadStatus,
      description: "Puede ver los Onboardings en estado Carga en proceso",
      roles: [
        Roles.sales,
        Roles.salesManager,
        Roles.producer,
        Roles.headOfProducers,
        Roles.admin,
        Roles.tenantAdmin,
        Roles.complianceOfficer,
        Roles.backOffice,
        Roles.trader,
        Roles.endClientUser,
        Roles.auneSupport,
      ],
    },
  ],
};

export default onboardingsStatusPermissions;
